import axios from "axios";
import { ExpandableKeys } from "../store/core";

export interface MenuItem {
  icon: string;
  id: number;
  items: MenuData;
  name: string;
  orderNum: number;
  parentId?: number | null;
  keys: ExpandableKeys;
  url?: string;
}
export type MenuData = Array<MenuItem>;

export interface MenuOption {
  id: number;
  name: string;
  level: number;
}

export default {
  getMenu() {
    return axios.get<MenuData>(`Navigation/Menu`);
  },
  getFlatMenu() {
    return axios.get("/Admin/NavigationItems");
  },
  getRemovableMenu() {
    return axios.get("/Admin/NavigationItems/Removable");
  },
  addMenuItem(data) {
    return axios.post(`/Admin/NavigationItems`, data);
  },
  updateMenuItem(id, data) {
    return axios.put(`/Admin/NavigationItems/${id}`, data);
  },
  deleteMenuItem(id) {
    return axios.delete(`/Admin/NavigationItems/${id}`);
  },
};
